import React,{useState,useEffect,useContext} from 'react'
import {
  Box,
  Image,
  Text,
  Link,
  VStack,
  Button,
  CloseIcon,
  Flex,
  Radio, 
  InfoOutlineIcon
} from "native-base";
import { useNavigate } from "react-router-dom";
import useScrollToTop from '../../../hooks/useScrollToTop'
import StyledButton from "../../../components/Button";
import { AppContext } from '../../../context';
import { style } from 'dom-helpers';
import Divider from '../../../components/Divider'
function ResaleLaMakanerie() {
  var la_makanerie_design = require('../../../images/dressThreeResale.png');
  var amarezza_design = require('../../../images/amarezza/MotifAmarezza.png');

  const navigate = useNavigate();
  const scrollToTop = useScrollToTop();
  const { getData,getParams} = useContext(AppContext);


  var resaleImage = require('../../../images/dressOneResale.png');

  const [selectedValue, setSelectedValue] = useState('');

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const radioStyle = {
    marginRight: '8px', // Equivalent to '2' in the provided scale if assuming a base-4 scale.
  };

  const textStyle = {
    color: getParams.style ==='acqua'? '#B03D01' : 
    getParams.style ==='amarezza'? '#DCA459D0' :'',
    fontWeight: 'extrabold',
    fontFamily: 'archivo_regular',
  };

  const groupStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderColor:  getParams.style ==='acqua'? '#B03D01' : 
    getParams.style ==='amarezza'? '#DCA459D0' :'',
  };

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop]);


  return (
    <>
    <VStack alignItems="flex-start" space={0} px={"4"} paddingTop={'4'}>
    <VStack alignItems="flex-start" space={4} px={"4"} paddingTop={'4'}>
              <Button onPress={() => navigate(-1)} variant={'unstyled'}><CloseIcon color={
                getParams.style ==='acqua'? '#B03D01' : 
                getParams.style ==='amarezza'? '#DCA459D0':'#000000'
              } size={"5"}/></Button>
          </VStack>
    </VStack>
    <VStack alignItems={"center"} marginBottom={"8"}>
      <Text color={"#000000"}  fontSize={"4xl"} fontFamily={'archivo_regular'}>Revendre</Text>
    </VStack>
    <VStack alignItems={"center"} space={0} px={"4"} marginBottom={8} textAlign={'center'}>
      <Text color={"#000000"}  fontSize={"2xl"} alignContent={"center"} fontFamily={'archivo_regular'}>
      Vous voulez revendre votre <br></br>foulard ?
      </Text>
      <VStack alignItems={"center"} marginTop={'20px'}>
      <Text color={"#000000"} fontFamily={'AttilaSansBasic Light'}
      fontWeight={'300'}
      >Vendre votre produit avec Vestiaire Collective.</Text>
      </VStack>
      <VStack alignItems={"center"} marginTop={'20px'}>
      <Image
          source={{ uri: getParams.style==='acqua' ? la_makanerie_design : getParams.style === 'amarezza'? amarezza_design :'' }}
          alt="Alternate Text"
          size="xl"
          width="333px"
          height="365px"
      />
      </VStack>
    </VStack>
    <Flex justifyContent={'space-between'} direction="row" px={'4'} marginBottom={'2'}>
          <Text fontFamily={'AttilaSansBasic Light'}
      fontWeight={'300'} color={"#000000"}>Prix d’achat:</Text>
          <Text fontFamily={'AttilaSansBasic Light'}
      fontWeight={'300'}
      color={"#000000"}>290 €</Text>
    </Flex>
    {/* <Flex justifyContent={'space-between'} direction="row" px={'4'}>
          <Text color={"#1341B6"}>Date of purchase</Text>
          <Text color={"#1341B6"}>16 March 2023</Text>
    </Flex> */}
    <VStack alignItems={'center'} mx={'2'} marginTop={'8'} marginBottom={'4'}>
    <Divider width="95%" color={getParams.style==='acqua'? '#B03D01' :
                    getParams.style==='amarezza'?
                    '#DCA459D0' : '#000000'} />
    </VStack>
    <VStack alignItems={'flex-start'} px={4} marginBottom={'4'}>
      <Text fontFamily={'archivo_regular'} color="#000000" >Retour À La Page Revente <InfoOutlineIcon color="#000000" fontSize="xs" height="10px" width="10px"/></Text>
    </VStack>
    <Flex direction="row" px={'4'} justifyContent={'space-between'} alignItems={'center'}>
    <div style={groupStyle}>
      <input
        type="radio"
        value="vestiaireCollective"
        name="radioGroup"
        checked={selectedValue === "vestiaireCollective"}
        onChange={handleChange}
        style={radioStyle}
      />
      <label style={textStyle}>
        Vestiaire <br /> Collective
      </label>
    </div>
    
    {/* <Text color={"#000000"} fontWeight={'extrabold'} fontFamily={'bodyBold'}>Estimated resale price 295 € </Text> */}
    </Flex>
    <VStack alignItems={'center'} px={4} py={2} marginTop={'24px'}>
        <StyledButton
                    text={'ContinueR'}
                    backgroundColor={getParams.style==='acqua'? '#B03D01' :
                    getParams.style==='amarezza'?
                    '#DCA459D0' : '#000000'}
                    textColor="#FFFFFF"
                    borderColor="transparent"
                    width="100%"
                    height="54px"
                    hoverBackgroundColor="#FFFFFF"
                    hoverTextColor={getParams.style==='acqua'? '#B03D01' :
                    getParams.style==='amarezza'?
                    '#DCA459D0' : '#000000'}
                    hoverBorderColor={getParams.style==='acqua'? '#B03D01' :
                    getParams.style==='amarezza'?
                    '#DCA459D0' : '#000000'}
                  />
    </VStack>
    
    </>
  );
}

export default ResaleLaMakanerie;
